import { atom, selector, useRecoilState } from 'recoil';
import { articlesTypeState } from './articlesState';

export const questionsState = atom({
  key: 'questionsState',
  default: selector({
    key: 'selectorQuestionsState',
    get: async ({ get }) => {
      const articlesType = get(articlesTypeState);
      console.log('articlesType', articlesType);
      if (articlesType === 'mc') {
        const response = await fetch(
          `${process.env.REACT_APP_PATH_LOCAL}wp-json/wp/v2/pages?slug=dx-for-mc`
        );
        if (response.error) {
          throw response.error;
        }
        const res = await response.json();
        return res[0].acf.questions;
      } else if (articlesType === 'bm') {
        const response = await fetch(
          `${process.env.REACT_APP_PATH_LOCAL}wp-json/wp/v2/pages?slug=dx-for-bm`
        );
        if (response.error) {
          throw response.error;
        }
        // return await response.json();
        const res = await response.json();
        return res[0].acf.questions;
      } else if (articlesType === 'expenses') {
        const response = await fetch(
          `${process.env.REACT_APP_PATH_LOCAL}wp-json/wp/v2/pages?slug=chintai_shindan`
        );
        if (response.error) {
          throw response.error;
        }
        // return await response.json();
        const res = await response.json();
        return res[0].acf.questions;
      }
    },
  }),
});

const catState = selector({
  key: 'catState',
  get: ({ get }) => {
    const list = get(questionsState);
    console.log('list', list);
    const catLists = list.map((item) => item.cat);
    let catList = Array.from(
      new Map(catLists.map((cat) => [cat.term_id, cat])).values()
    );
    return catList;
  },
});



const rateState = atom({
  key: 'rateState',
  default: 0,
});

export const UsequestionsState = () => {
  const [list, setlist] = useRecoilState(questionsState);
  const [catList] = useRecoilState(catState);
  const [rate, setRate] = useRecoilState(rateState);

  return {
    list,
    setlist,
    rate,
    setRate,
    catList,
  };
};
